import { get } from "../../utils/request";

export const fetchDevices = async (): Promise<unknown> => {
  const devicePath = "/api/internal/devices";
  return get(devicePath);
};
